import {
  Box,
  IconButton,
  SwipeableDrawer,
  Tab,
  Tabs,
  useMediaQuery,
} from "@mui/material";
import React, { useState } from "react";
import {
  Home,
  PermIdentity,
  Public,
  Person,
  CalendarMonth,
  Add,
} from "@mui/icons-material";
import { colors } from "../theme/theme";
import NavBar from "./NavBar";
import MobileDrawer from "./MobileDrawer";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Footer from "../Components/Common/Footer";

const Layout = ({ children, showHeaders }) => {
  showHeaders = showHeaders == undefined ? true : showHeaders;
  const location = useLocation();
  const navigate = useNavigate();
  const { userData } = useSelector((state) => state.user);
  const smallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const tabMapping = {
    "/dashboard": "Home",
    "/creator/": "Profile", // Base path for dynamic routes
    "/community": "Community",
    "/calendar": "Calendar",
  };
  const getTabName = (pathname) => {
    const matchedKey = Object.keys(tabMapping).find((key) =>
      pathname.startsWith(key)
    );
    return tabMapping[matchedKey] || ""; // Default to empty if no match
  };

  const selectedTab = getTabName(location.pathname);

  const [state, setState] = useState({
    right: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };

  return (
    <Box
      sx={{
        backgroundColor: colors.bg,
        minHeight: "100vh",
      }}
    >
      {showHeaders && (
        <NavBar setState={setState} toggleDrawer={toggleDrawer} />
      )}

      <SwipeableDrawer
        anchor="right"
        open={state.right}
        onClose={toggleDrawer("right", false)}
        onOpen={toggleDrawer("right", true)}
      >
        <MobileDrawer toggleDrawer={toggleDrawer} />
      </SwipeableDrawer>

      <Box sx={{ flex: 1, p: smallScreen ? 2 : 4 }}>{children}</Box>

      <Footer />

      {showHeaders && smallScreen && (
        <Box
          sx={{
            position: "fixed",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            bottom: 0,
            backgroundColor: "#fff",
            zIndex: 99,
          }}
        >
          {userData.role === "user" && (
            <Tabs
              value={selectedTab}
              textColor="inherit"
              aria-label="secondary tabs example"
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                "& .MuiTab-root": {
                  fontSize: "12px",
                  flex: 1,
                  maxWidth: "50%",
                  opacity: 1,
                  borderTop: "2px solid transparent",
                  fontWeight: 600,
                },
                "& .Mui-selected": {
                  color: "#FC0108",
                  borderTop: "2px solid #FC0108 !important",
                },
              }}
            >
              <Tab
                icon={<Home />}
                sx={{ px: 1 }}
                value="Home"
                label="Dashboard"
                onClick={() => navigate("/")}
                className="step-1"
              />
              <Tab
                icon={
                  selectedTab === "Creators" ? <Person /> : <PermIdentity />
                }
                sx={{ px: 1 }}
                value="Profile"
                label="Account"
                onClick={() => navigate(`/creator/${userData?.id}`)}
              />
              <Tab
                icon={<Public />}
                sx={{ px: 1 }}
                value="Community"
                label="Community"
                onClick={() => navigate("/community")}
                className="step-3-1"
              />
              <Tab
                icon={<CalendarMonth />}
                sx={{ px: 1 }}
                value="Calendar"
                label="Training Hub"
                onClick={() => navigate("/calendar")}
              />
            </Tabs>
          )}

          {userData.creatorId && userData.role === "user" && (
            <IconButton
              sx={{
                position: "absolute",
                top: "-15px",
                left: "50%",
                transform: "translateX(-50%)",
                backgroundColor: "#FC0108",
                color: "white",
                width: "50px",
                height: "50px",
                borderRadius: "50%",
                boxShadow: "0px 4px 6px rgba(0,0,0,0.2)",
              }}
              onClick={() => navigate("/creator/upload-content")}
            >
              <Add fontSize="large" />
            </IconButton>
          )}
        </Box>
      )}
    </Box>
  );
};

export default Layout;
